import { render, staticRenderFns } from "./ThoSuaChua.vue?vue&type=template&id=0f21813a&scoped=true"
import script from "./ThoSuaChua.vue?vue&type=script&lang=js"
export * from "./ThoSuaChua.vue?vue&type=script&lang=js"
import style0 from "./ThoSuaChua.vue?vue&type=style&index=0&id=0f21813a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f21813a",
  null
  
)

export default component.exports